module.exports = __webpack_public_path__ + "files/b9fa997be5f29c8e679c631f13f319f0.png";